'use strict';

export default {
	labelsURL: '/labels-b2b/',
}
